import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { PUR1040_R01DetailDto, PUR1040_R01Dto, PUR1040_R01HeaderDto } from './Dto_PUR1040_R01';
import { PUR1040_R01Filter } from "./Store_PUR1040_R01";

const baseUrl = `${config.apiUrl}/PUR1040_R01`;

const getParams = (filter: Partial<PUR1040_R01Filter>, listLength?: number) => {
	return {
		compCd: filter.compCd || undefined,
		customCd: filter.customCd || undefined,
        empNo: filter.empNo || undefined,
		itemGroup: filter.itemGroup || undefined,
		brandCd: filter.brandCd || undefined,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		logicCenter: filter.logicCenter || undefined,
		listLength: listLength || 0
	}
}

export const getPUR1040_R01List = async (option: string, params: Partial<PUR1040_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

    return await getData<ResponseDto<PUR1040_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getPUR1040_R01AllCount = async (params: Partial<PUR1040_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getPUR1040_R01DetailList = async (purchaseOrderNo: string) => {
	const url = `${baseUrl}/detail/${purchaseOrderNo}`;

    return await getData<ResponseDto<PUR1040_R01DetailDto[]>>(url);
}



export const downloadExcel_PUR1040_R01 = async (purchaseOrderNo: string) => {
	const url = `${baseUrl}/excel/${purchaseOrderNo}`;
    return await getData<ResponseDto<string>>(url);
};
